import { useEffect, useState } from "react";
import CreateNewElectionsDesktop from "./CreateNewElectionsDesktop";
import CreateNewElectionsMobile from "./CreateNewElectionsMobile";
import "./NewElections.scss";

const NewElections = () => {
  // const [width, setWidth] = useState(window.innerWidth);

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  // }
  // useEffect(() => {
  //   window.addEventListener("resize", handleWindowSizeChange);
  //   return () => {
  //     window.removeEventListener("resize", handleWindowSizeChange);
  //   };
  // }, []);
  // const isMobile = width <= 960;

  // if (isMobile) {
  //   return <CreateNewElectionsMobile />;
  // } else {
  //   return <CreateNewElectionsDesktop />;
  // }
  return <CreateNewElectionsDesktop />;
};

export default NewElections;
